import slugify from 'slugify';

const turnInSlug = (string) => {
	return slugify(string, {
		replacement: '-',
		remove: /[*+~.()'"!:@]/g,
		lower: true,
	});
};

const handleFilter = (cardsContainer, filters) => {
	const cards = cardsContainer.querySelectorAll('.card');
	let url = window.location.href;
	let urlParams = new URLSearchParams(window.location.search);
	let searchParams = new URLSearchParams();

	if (filters && filters.length > 0) {
		// Build URL from current selections (ignore existing URL params)
		filters.forEach((filter) => {
			if (filter.filters.length > 0) {
				searchParams.append(turnInSlug(filter.name), filter.filters.join(','));
			}
		});

		const baseUrl = url.split('?')[0];
		const query = searchParams.toString();
		window.history.pushState({}, '', query ? `${baseUrl}?${query}` : `${baseUrl}`);

		cards.forEach((card) => {
			const cardFilters = card.querySelectorAll('.tags');
			const filterMatches = filters.every((filter) => {
				return Array.from(cardFilters).some((cardFilter) => {
					const title = cardFilter.querySelector('.tag-title').innerText;
					const cardFilterItems = Array.from(
						cardFilter.querySelectorAll('li')
					).map((item) => item.innerText);

					if (filter.filters.length > 0) {
						if (filter.name.includes(title)) {
							return filter.filters.some((term) =>
								cardFilterItems.includes(term)
							);
						}
						return false;
					}
					return true;
				});
			});

			filterMatches
				? card.classList.remove('unmatch')
				: card.classList.add('unmatch');
		});
	} else if (window.location.search) {
		const urlFilters = Array.from(urlParams.keys()).map((key) => {
			return {
				name: key,
				filters: urlParams.get(key).split(','),
			};
		});
		cards.forEach((card) => {
			const cardFilters = card.querySelectorAll('.tags');

			const filterMatches = urlFilters.every((filter) => {
				return Array.from(cardFilters).some((cardFilter) => {
					const title = turnInSlug(
						cardFilter.querySelector('.tag-title').innerText
					);
					const cardFilterItems = Array.from(
						cardFilter.querySelectorAll('li')
					).map((item) => item.innerText);

					if (filter.filters.length > 0) {
						if (filter.name.includes(title)) {
							return filter.filters.some((term) =>
								cardFilterItems.includes(term)
							);
						}
						return false;
					}
					return true;
				});
			});
			filterMatches
				? card.classList.remove('unmatch')
				: card.classList.add('unmatch');
		});
	}

	const resultsNumber = cardsContainer.querySelectorAll('.unmatch');
	if (resultsNumber.length === cards.length) {
		const noResults = document.createElement('p');
		noResults.classList.add('no-results');
		noResults.innerText = 'Aucun résultat trouvé';
		cardsContainer.appendChild(noResults);
	} else if (cards.length - resultsNumber.length <= 9) {
		const showMoreCards = document.getElementById('show-more-sejour');
		showMoreCards.style.display = 'none';
	}
};

const handleFilterSearch = (cardsContainer, filters) => {
	const cards = cardsContainer.querySelectorAll('.card');

	cards.forEach((card) => {
		const cardFilters = card.querySelectorAll('.tags');
		const filterMatches = filters.every((filter) => {
			return Array.from(cardFilters).some((cardFilter) => {
				const title = cardFilter.querySelector('.tag-title').innerText;
				const cardFilterItems = Array.from(
					cardFilter.querySelectorAll('li')
				).map((item) => item.innerText);

				if (filter.filters.length > 0) {
					if (filter.name.includes(title)) {
						return filter.filters.some((term) =>
							cardFilterItems.includes(term)
						);
					}
					return false;
				}
				return true;
			});
		});

		filterMatches
			? card.classList.remove('unmatch')
			: card.classList.add('unmatch');
	});

	const resultsNumber = cardsContainer.querySelectorAll('.unmatch');
	if (resultsNumber.length === cards.length) {
		const noResults = document.createElement('p');
		noResults.classList.add('no-results');
		noResults.innerText = 'Aucun résultat trouvé';
		cardsContainer.appendChild(noResults);
	}
};

export { handleFilter, handleFilterSearch };
